import { render } from "./RegistrationPage.vue?vue&type=template&id=78d60818&scoped=true&ts=true"
import script from "./RegistrationPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationPage.vue?vue&type=script&lang=ts"

import "./RegistrationPage.vue?vue&type=style&index=0&id=78d60818&lang=css&scoped=true"
import "./RegistrationPage.vue?vue&type=style&index=1&id=78d60818&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d60818"]])

export default __exports__